import {createAction} from 'redux-actions'

export const update = createAction('FIRMWARE/STORE/UPDATE', appliances => ({appliances}))
export const clear = createAction('FIRMWARE/STORE/CLEAR')
export const purge = createAction('FIRMWARE/STORE/PURGE')